const POINTS = [
  { at: "Class 9–10", title: "Choosing subjects and streams", text: "The first big fork in the road, and often the one that feels the most uncertain." },
  { at: "Class 12", title: "Picking courses and colleges", text: "So many options, entrance exams and opinions, all arriving at once." },
  { at: "And beyond", title: "Finding work that feels like you", text: "A path that fits your interests is easier to enjoy and to keep growing in." },
];

function Marker({ i }) {
  if (i === 2) return <svg viewBox="0 0 24 24" className="h-7 w-7" aria-hidden="true"><path d="M6 21V4" stroke="#4F0341" strokeWidth="2" strokeLinecap="round" /><path d="M6 4h11l-2.5 4L17 12H6" fill="#D9822B" /></svg>;
  if (i === 1) return <svg viewBox="0 0 24 24" className="h-7 w-7" aria-hidden="true"><path d="M12 22s7-6.2 7-12a7 7 0 1 0-14 0c0 5.8 7 12 7 12Z" fill="#4F0341" /><circle cx="12" cy="10" r="2.6" fill="#FBF6EF" /></svg>;
  return <span className="block h-5 w-5 rounded-full border-[3px] border-ds-plum bg-ds-cream" />;
}

export default function WhyItMatters() {
  return (
    <section id="why" className="ds-section bg-ds-cream" data-testid="landing-why-it-matters">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-16" data-reveal>
          <h2 className="ds-h2 lg:col-span-6">Big choices are coming. Knowing yourself makes them lighter.</h2>
          <div className="lg:col-span-6 space-y-4 text-[17px] text-ds-inksoft leading-relaxed lg:pt-2">
            <p>When students understand what they enjoy and how they like to work, these choices start to feel less like guesses and more like natural next steps.</p>
            <p>And when parents understand it too, conversations at home become calmer, kinder and more confident.</p>
          </div>
        </div>
        <div className="relative mt-14 md:mt-20" data-reveal>
          <div className="hidden md:block absolute left-0 right-0 top-[13px] route-divider" aria-hidden="true" />
          <div className="md:hidden absolute left-[13px] top-2 bottom-2 w-[14px] route-divider [background-repeat:repeat-y]" aria-hidden="true" />
          <div className="hidden md:flex justify-between text-xs font-semibold text-ds-inksoft absolute -top-7 left-0 right-0"><span>Class 7</span><span>Class 12 and beyond</span></div>
          <ol className="relative grid md:grid-cols-3 gap-10 md:gap-8">
            {POINTS.map((p, i) => (
              <li key={p.title} className="relative pl-12 md:pl-0" data-testid={`why-moment-${i}`}>
                <span className="absolute left-0 md:static flex h-7 w-7 items-center justify-center bg-ds-cream"><Marker i={i} /></span>
                <p className="md:mt-5 text-sm font-semibold text-ds-plum">{p.at}</p>
                <h3 className="mt-1 font-display text-2xl font-semibold text-ds-plumdeep">{p.title}</h3>
                <p className="mt-2 text-[15px] text-ds-inksoft leading-relaxed max-w-xs">{p.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
